export default __webpack_public_path__ + "static/media/renda-fixa.2a9dda87.svg";